import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { SignInPage }      from './pages/SignInPage';
import { MicrosoftCallbackPage } from './pages/MicrosoftCallbackPage';
import { OrgSetupPage }    from './pages/OrgSetupPage';
import { DashboardPage }   from './pages/DashboardPage';
import { ApprovalsPage }   from './pages/ApprovalsPage';
import { MembersPage }     from './pages/MembersPage';
import { GroupsPage }      from './pages/GroupsPage';
import { TeamsPage }       from './pages/TeamsPage';
import { QuestionBankPage }from './pages/QuestionBankPage';
import { InsightsPage }    from './pages/InsightsPage';
import { ModerationPage }  from './pages/ModerationPage';
import { SettingsPage }    from './pages/SettingsPage';
import { BillingPage }     from './pages/BillingPage';
import { AuditLogPage }    from './pages/AuditLogPage';

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/auth/microsoft/callback" element={<MicrosoftCallbackPage />} />

      {/* Org setup — authenticated but pre-org */}
      <Route element={<ProtectedRoute />}>
        <Route path="/setup" element={<OrgSetupPage />} />
      </Route>

      {/* Console — authenticated + has org membership */}
      <Route element={<ProtectedRoute minRole="member" />}>
        <Route element={<Layout />}>
          <Route path="/"              element={<DashboardPage />} />
          <Route path="/approvals"     element={<ApprovalsPage />} />
          <Route path="/members"       element={<MembersPage />} />
          <Route path="/groups"        element={<GroupsPage />} />
          <Route path="/teams"         element={<TeamsPage />} />
          <Route path="/question-bank" element={<QuestionBankPage />} />
          <Route path="/insights"      element={<InsightsPage />} />
          <Route path="/moderation"    element={<ModerationPage />} />
          <Route path="/settings"      element={<SettingsPage />} />
          <Route path="/billing"       element={<BillingPage />} />
          <Route path="/audit-log"     element={<AuditLogPage />} />
        </Route>
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
